import Autocomplete from '@components/v2/form/Autocomplete/Autocomplete';
import LangEnum from '../../../../../../lang/LangEnum';
import { getFormattedCodeName } from '../../../../../../utils/formatters';
import { onScrollEndReload } from '../../../../../../utils/generics';
import { useTranslation } from '../../../../../translation/TranslationContext';
import useClassificationTypeSelect from './hooks/useClassificationTypeSelect';
import {
  CatalogClassificationType,
  ClassificationTypeSelectProps,
} from './interfaces/classificationTypeSelect.types';

const ClassificationTypeSelect = ({
  disabled,
  catalogId,
  handleChange,
  initialClassificationTypeId,
}: ClassificationTypeSelectProps) => {
  const { translate } = useTranslation();
  const {
    options,
    inputText,
    listPickActions,
    handleChangeInput,
    selectedClassificationType,
    setSelectedId,
  } = useClassificationTypeSelect({
    disabled,
    catalogId,
    initialClassificationTypeId,
  });

  return (
    <Autocomplete<CatalogClassificationType>
      clearOnBlur
      disabled={disabled}
      options={options}
      value={selectedClassificationType}
      inputValue={inputText}
      loading={listPickActions.loading}
      onInputChange={handleChangeInput}
      noOptionsText={translate(LangEnum.GLOBAL_NO_OPTIONS)}
      loadingText={translate(LangEnum.GLOBAL_SEARCHING)}
      getOptionLabel={(option) => getFormattedCodeName(option.name)}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      textFieldProps={{
        label: translate(LangEnum.CATALOGS_EXPORT_CLASSIFICATION_INPUT_LABEL),
      }}
      slotProps={{
        listbox: {
          style: { maxHeight: 248 },
          onScroll: (event: React.SyntheticEvent) => onScrollEndReload(event, listPickActions),
        },
      }}
      onChange={(_, classificationType) => {
        if (!classificationType) {
          handleChange(null);
          setSelectedId(null);
          return;
        }
        if (classificationType.id === selectedClassificationType?.id) {
          return;
        }
        handleChange(classificationType);
        setSelectedId(classificationType.id);
      }}
    />
  );
};

export default ClassificationTypeSelect;
